import './index.css';

export default {
  name: 'Aflex',
  render() {
    const { direction = 'column', ...attrs } = this.$attrs;
    return (
      <div class="a-flex" style={{ flexDirection: this.direction.includes('col') ? 'column' : 'row', ...attrs }}>
        {this.$slots.default}
      </div>
    );
  },
}